var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "neon-svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#776e03",
    d: "M1350 2991 c-175 -19 -370 -75 -520 -151 -288 -145 -550 -413 -683 -701 -254 -546 -164 -1184 230 -1631 420 -477 1093 -636 1684 -399 455 183 802 598 904 1081 57 272 31 590 -70 852 -78 202 -178 353 -344 519 -218 217 -469 351 -764 408 -118 23 -327 33 -437 22z m440 -170 c850 -197 1301 -1119 930 -1899 -230 -482 -695 -776 -1225 -774 -643 3 -1181 444 -1321 1083 -24 110 -29 342 -10 464 77 504 416 913 896 1083 75 26 181 51 275 66 76 11 372 -3 455 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#776e03",
    d: "M2055 2191 c-27 -10 -367 -143 -755 -295 -617 -242 -709 -281 -737 -311 -37 -39 -42 -78 -18 -125 20 -38 42 -49 237 -116 90 -31 167 -60 171 -64 5 -4 37 -99 71 -211 85 -275 93 -289 170 -289 31 0 49 12 141 96 63 58 111 94 119 91 8 -3 72 -50 142 -105 193 -149 198 -152 260 -152 45 0 59 5 87 30 19 16 39 42 45 57 6 16 68 319 138 675 116 587 126 649 114 678 -25 59 -93 75 -185 41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5608346fd6d2ea19fb52767ffb156168.svg";
export { ForwardRef as ReactComponent };